export var Device;
(function (Device) {
  Device["Desktop"] = "desktop";
  Device["Mobile"] = "mobile";
})(Device || (Device = {}));